import dictionary from './dictionary.json.js';
const config = {
    resource: 'next-feedback',
    dictionary,
};
export default config;
//# sourceMappingURL=config.js.map